"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import 'react-aria-components';
import { Tooltip } from '../components/Tooltip/Tooltip.mjs';
import { viewComponentContext } from '../lib/viewComponentContext/viewComponentContext.mjs';

const TooltipView = (props) => {
  const View = useContext(viewComponentContext)["Tooltip"] ?? Tooltip;
  return /* @__PURE__ */ jsx(View, { ...props });
};

export { TooltipView as default };
//# sourceMappingURL=TooltipView.mjs.map
